//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PublicService from '@/service/public'
import SubscribeTip from '../_components/_subscribe_tip'
import { App_User } from '@/data/user_info'

export default {
    components: {
        SubscribeTip
    },
    methods: {
        goConsultant () {
            wx.navigateTo({
                url: `/consultants/filter/main?id=${this.building_id}`
            })
        },
        goConsultantByUser (e) {
            this.$sendCtmEvtLog('评论列表-吸底在线咨询')
            this.goConsultant()
        },
        goCall () {
            this.$showCallModal(this.getPhoneCall, '楼盘评论页——电话拨打')
        },
        getPhoneCall () {
            PublicService.getPhonePosition({
                building_id: this.building_id
            }).then(({ phone }) => {
                wx.makePhoneCall({
                    phoneNumber: phone,
                    success: () => {}
                })
            })
        },
        showComment (e) {
            App_User.fetchUser().then((user) => {
                if (user.tag_list[0] == "天府通游客") {
                    wx.navigateTo({
                        url: '/logging_in'
                    })
                    return
                } else {
                    this.$emit('openComment')
                }
            })
        }
    },
    props: {
        building_id: {
            type: [Number, String]
        },
        favourite: {
            type: Boolean
        },
        follow_info: {
            follow_info: Object
        },
        add_group_url: String
    }
}
